import { Icon, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import classNames from "classnames";
import { DataDisplayRecord } from "components/data-display";
import { GridLayout } from "components/grid";
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { GreyFleetInsuranceCoverRecords, getCoverRecordsColumnCount } from "./GreyFleetInsuranceCoverRecords";

export function GreyFleetInsuranceDetails({ loading, insuranceDetails, coverTypes }) {
    const validIconName = IconNames.TickCircle;
    const failIconName = IconNames.BanCircle;
    const invalidIconName = IconNames.Error;

    const aiResult = useMemo(() => {
        let iconIntent;
        let iconName;
        let text;
        if (insuranceDetails?.ai?.errored) {
            iconIntent = Intent.DANGER;
            iconName = failIconName;
            text = "Error";
        }
        else if (insuranceDetails?.ai?.completed) {
            if (insuranceDetails?.ai?.result) {
                iconIntent = Intent.SUCCESS;
                iconName = validIconName;
                text = "Valid";
            }
            else {
                iconIntent = Intent.DANGER;
                iconName = failIconName;
                text = "Fail";
            }
        }
        else {
            iconIntent = Intent.WARNING;
            iconName = invalidIconName;
            text = "Awaiting";
        }
        return (
            <div className="inline-items">
                <Icon intent={iconIntent} icon={iconName} size={12} />
                <span>{text}</span>
            </div>
        );
    }, [insuranceDetails]);

    const numberOfColumns = useMemo(() => {
        return getCoverRecordsColumnCount(insuranceDetails?.userInput, coverTypes);
    }, [insuranceDetails, coverTypes]);

    return (
        <div className="spacer-bottom">
            <h2>Details</h2>
            <GridLayout gap={40} numberOfColumns={numberOfColumns} className={classNames({ "bp6-skeleton": loading })}>
                <DataDisplayRecord header="Insurance Check ID" data={insuranceDetails?.checkId} />
                <DataDisplayRecord header="Account" data={`${insuranceDetails?.accountMemberNumber} - ${insuranceDetails?.accountName}`} />
                <DataDisplayRecord header="AI Results" data={aiResult} />
                <DataDisplayRecord header="Human Validation Requested" data={insuranceDetails?.ai?.completed ? "Yes" : "No"} />
                <GreyFleetInsuranceCoverRecords
                    loading={loading}
                    userInput={insuranceDetails?.userInput}
                    coverTypes={coverTypes}
                />
            </GridLayout>
        </div>
    );
}

GreyFleetInsuranceDetails.propTypes = {
    loading: PropTypes.bool.isRequired,
    insuranceDetails: PropTypes.object,
    coverTypes: PropTypes.array
};
